import { createContext, useContext, useState, useEffect } from "react";
import getConfiguraciones from "../services/configuracion/getConfiguraciones.js";
import { useAuth } from "../hooks/useAuth";

const ConfigContext = createContext();

export const ConfigProvider = ({ children }) => {
  const [cancelacionAutomatica, setCancelacionAutomatica] = useState(null);
  const { isAuthenticated } = useAuth();

  const fetchCancelacionConfig = async () => {
    try {
      const { data } = await getConfiguraciones();
      if (!Array.isArray(data)) {
        console.error("Error al obtener configuración:", data?.error || data?.message || data);
        return;
      }
      const config = data.find(cfg => cfg.clave === "turno.tolerancia_llegada_turno");
      if (config) {
        setCancelacionAutomatica(config.activo === true || config.activo === 1);
      }
    } catch (err) {
      console.error("Error al obtener configuración:", err);
    }
  };

  useEffect(() => {
    if (isAuthenticated) {
      fetchCancelacionConfig();
    } else {
      setCancelacionAutomatica(null);
    }
  }, [isAuthenticated]);

  const refreshConfig = () => {
    if (isAuthenticated) {
      fetchCancelacionConfig();
    }
  };

  return (
    <ConfigContext.Provider value={{ cancelacionAutomatica, refreshConfig }}>
      {children}
    </ConfigContext.Provider>
  );
};

export const useConfig = () => {
  const context = useContext(ConfigContext);
  if (!context) {
    throw new Error("useConfig must be used within a ConfigProvider");
  }
  return context;
};